import React from 'react';
import { useSelector } from 'react-redux';

import { GPSRaw as GPSRawUI } from '@/components/ui/dashboard/Monitor';

const GPSRaw = ({ data: robotId }) => {
  const gpsRaw = useSelector((state) => state.telemetry[robotId]?.gpsRaw);

  return (
    <GPSRawUI
      latitude={(gpsRaw?.lat ?? 0) / 1e7}
      longitude={(gpsRaw?.lon ?? 0) / 1e7}
      altitude={(gpsRaw?.alt ?? 0) / 1e3}
      satellites={gpsRaw?.satellitesVisible ?? 0}
      eph={gpsRaw?.eph ?? 0}
      epv={gpsRaw?.epv ?? 0}
      time={(gpsRaw?.timeUsec ?? 0) / 1e6}
      showData
    />
  );
};

export default GPSRaw;
